<template>
  <div class="lego-table-wrap">
    <lego-paging-table
      ref="list"
      title
      multiSelect
      selectAll
      v-model="selectedItems"
      :noPage="true"
      :noDataText="noDataText"
      :items="items"
      :headers="headers"
      :selectActionControl="false"
      :scrollFixRow="scrollFixRow"
      :scrollMaxRow="scrollMaxRow"
      :selectMaxCnt="selectMaxItem"
      :valueKey="valueKey"
      :messageMaxCnt="
        $t('page.performance.monitoringTargetMaxLimite', {
          max: maxSelected,
          asg: asgVm
        })
      "
      @sort="onSort"
      @update:modelValue="onCheck"
      @inputAll="onCheck"
      :noControl="false"
    ></lego-paging-table>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import { scpmUtil } from '@/utils/scpmUtil.js';
import TooltipAndOther from '@/containers/components/TooltipAndOther';

export default {
  name: 'MonitoringASGTable',
  props: {
    searchText: {
      type: String,
      default: ''
    },
    productType: {
      type: String,
      required: true
    },
    scrollFixRow: {
      type: Number,
      default: null
    },
    scrollMaxRow: {
      type: Number,
      default: 6
    },
    selectMaxItem: {
      type: Number,
      default: 10
    },
    selected: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: () => 'groupIfKey'
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler(newValue) {
        this.selectedItems = [...newValue];
      }
    }
  },
  data() {
    return {
      selectedItems: [],
      items: [],
      noDataText: '',
      headers: [
        {
          text: this.$t('searchLabel.asgName'),
          value: 'groupName',
          sortable: true,
          defaultValue: '-',
          isNotResize: true
        },
        {
          text: this.$t('searchLabel.asgId'),
          value: 'groupIfKey',
          sortable: false,
          defaultValue: '-',
          isNotResize: true
        },
        {
          text: this.$t('searchLabel.tag'),
          value: 'productTags',
          sortable: true,
          defaultValue: '',
          isNotResize: true,
          customCell: {
            name: 'TagInofs',
            components: { TooltipAndOther },
            props: {
              item: {
                type: Object,
                default: () => {}
              },
              iIdx: {
                type: Number
              }
            },
            template: `<TooltipAndOther :id='iIdx' v-if='item.productTags.length' :items='item.productTags' onlyShowAnd/>`
          }
        }
      ]
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters('searchStore', { isResetFilterXss: 'getResetFilterXss' }),
    asgVm() {
      return `/${this.$t('searchLabel.asgVM')}`;
    },
    maxSelected() {
      return this.$const.MAX_SELECTED;
    }
  },
  methods: {
    init() {
      this.getListASG();
    },

    execSearch(reset = false, textForSearch) {
      if (reset) this.$refs.list.$refs.table.resetSort();
      this.getListASG(null, textForSearch);
    },

    getListASG(params, textForSearch) {
      params = params || {};
      const param = {
        page: 0,
        size: 0,
        ...params,
        asgYn: 'Y',
        groupName: textForSearch || textForSearch === '' ? textForSearch : this.searchText,
        includeTags: 'Y'
      };

      this.$http.system
        .getListASG(param)
        .then((data) => {
          this.items = [];

          if (data) {
            this.items = data.contents.map((item) => {
              const tags = item.productTags || [];
              item.productTags = tags?.map((d) => scpmUtil.getTagText(d));
              item.firstProductTag = tags.length > 0 ? scpmUtil.getTagText(tags[0]) : '';
              item.productResourceId = item.groupIfKey;

              return {
                ...item,
                value: item.groupIfKey,
                label: item.groupName,
                isASG: true
              };
            });
          }
        })
        .catch(() => {
          if (this.isResetFilterXss) {
            this.selectedItems = [];
            this.$emit('onCheck', this.selectedItems);
            this.getListASG();
          }
          this.$emit('clearSearchText');
        });
    },

    async onCheck(selectedItems, isMaxSelection) {
      if (isMaxSelection) return;
      if (!selectedItems.length) return this.$emit('onCheck', selectedItems);
      const productResourceIds = selectedItems.map((item) => item.groupIfKey);
      const listDataCheckAuth = selectedItems.map((item) => {
        return {
          productResourceId: item.groupIfKey,
          productName: item.groupName
        };
      });

      const param = {
        productTypeCode: this.productType,
        actionName: this.$const.AuthorizationAction.MONITOR_VIEW,
        productResourceIds,
        listDataCheckAuth
      };

      const data = await this.$store.dispatch('authStore/checkProductResource', param);

      if (data.type === this.$const.AuthorizationResult.ALLOW)
        return this.$emit('onCheck', selectedItems);

      if (!data.resourceIds || !data.resourceIds.length) return;

      const remainSelected = selectedItems.filter(
        (item) => !data.resourceIds.includes(item['value'])
      );

      this.$refs.list.selected = remainSelected;
      this.selectedItems = remainSelected;

      await this.onCheck(this.selectedItems, isMaxSelection);
    },

    onSort({ asc, value }) {
      const { ASC: _ASC, DESC: _DESC } = this.$const.SORT_TYPES;
      if (value === 'productTags') {
        this.items = this.$util.customSort(this.items, 'firstProductTag', asc ? _ASC : _DESC);
      } else {
        const params = {
          sort: [`${value}:${asc ? _ASC : _DESC}`]
        };
        return this.getListASG(params);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lego-table-wrap {
  width: 100%;
  height: 500px;
}
</style>
